@if (_active) {
  <kendo-window
    [class.editFieldsModeClass]="_pageState == 4"
    title="{{ _pageState == 2 || _pageState == 5 ? 'ADD NEW RECORD' : _pageState == 3 ? 'EDIT RECORD' : _pageState == 1 ? 'VIEW RECORD' : _pageState == 4 ? 'EDIT FIELDS MODE' : '' }}"
    (close)="_closeForm()"
    (stateChange)="_onStateChanges($event)"
    class="fullWidthFormForm"
    [class.disabledPopup]="_editFormActive || _orderingTabsForm || _deactivatedFieldsForm"
    (keydown.enter)="$event.preventDefault()"
    #mainWindow>
    <!-- Form -->
    <form novalidate [formGroup]="_form" class="form_style">
      <div class="row special_row_margin">
        <div class="col-12 special_col_padding">
          <!-- <div class="border_sections margin-top-4 bordered-With-charts"> -->
          <div class="row special_row_margin">
            <div class="col-6 special_col_padding pb-2"
              [class.col-12]="_pageState == 2 || _pageState == 5 || _pageState == 4 || _currentUser.isEnterprise">
              <div class="border_sections margin-top-4 h-100 bordered-With-charts">
                <div class="row">
                  <div class="col-12">
                    <h2 class="formsTitle">
                      Unit Of Measure
                      @if (canAccess('uom', 'update')) {
                        <span (click)="_edit()"
                          [class.ViewModeVisibleElement]="_pageState == 1"
                          class="action-button action-button-viewMode">
                          <div class="action-button-icon">
                            <img src="/assets/menu/enterprise/edit-action-icon-grid.svg" />
                          </div>
                          <div class="edit-icon-text">Edit</div>
                        </span>
                      }
                    </h2>
                    <div class="upsert-header-buttons">
                      <ul class="menuButtonsList">
                        @if (canAccess('uom', 'update')) {
                          <li (click)="_onEditForms()"
                            [class.ViewModelHiddenElement]="_pageState != 2 && _pageState != 5">
                            Edit Forms
                          </li>
                        }
                        <li class="wikiButton"
                          (click)="_onEditFields()"
                          [class.ViewModeHiddenElement]="_pageState != 2 && _pageState != 5">
                          Edit Fields
                        </li>
                        <li class="wikiButton"
                          (click)="_returnAdNew()"
                          [class.ViewModeHiddenElement]="_pageState != 4">
                          Close Edit Fields
                        </li>
                        <!-- <li [class.ViewModeHiddenElement]="_pageState == 1">Edit Forms</li> -->
                        <!-- <li class="wikiButton">Wiki</li> -->
                        @if ((_pageState == 2 || _pageState == 5) && !_currentUser.isEnterprise) {
                          <li
                            class="wikiButton"
                            [class.disabled]="_deactivatedFieldsGridData?.length == 0"
                            (click)="_viewInactiveFields();_deactivatedFieldsForm=true">
                            View Inactive Fields
                          </li>
                        }
                        @if (_pageState == 2) {
                          <li
                            class="wikiButton"
                            [class.disabled]="_deactivatedFormTabsGridData?.length == 0"
                            (click)="_viewInactiveFormTabs();_deactivatedFormTabsForm=true"
                            >
                            View Inactive Form Tabs
                          </li>
                        }
                      </ul>
                      @if (_pageState != 1) {
                        <div>
                          <button kendoButton
                            class="steps_buttons_class"
                            (click)="_onCancel()">
                            <img class="backimage"
                              [src]="'/assets/menu/'+ _theme +'/close-schedule-report-icon-green.svg'" />
                              <span>close</span>
                            </button>
                            @if (canAccess('uom', 'create')) {
                              <button
                                kendoButton
                                class="steps_buttons_class"
                                [disabled]="_pageState == 4 ? true : false"
                                (click)="_onSave('saveAndCopy')">
                                <img class="backimage"
                                  [src]="'/assets/menu/'+ _theme +'/save-icon-group.svg'" />
                                  <span>save & Copy</span>
                                </button>
                              }
                              @if (canAccess('uom', 'create')) {
                                <button
                                  kendoButton
                                  class="steps_buttons_class"
                                  [disabled]="_pageState == 4 ? true : false"
                                  (click)="_onSave('saveAndNew')">
                                  <img class="backimage"
                                    [src]="'/assets/menu/'+ _theme +'/save-icon-group.svg'" />
                                    <span>save & New</span>
                                  </button>
                                }
                                <button kendoButton
                                  class="steps_buttons_class"
                                  [disabled]="_pageState == 4 ? true : false"
                                  (click)="_onSave('saveAndClose')">
                                  <img class="backimage"
                                    [src]="'/assets/menu/'+ _theme +'/save-icon-group.svg'" />
                                    <span>save & Close</span>
                                  </button>
                                  <button kendoButton
                                    class="steps_buttons_class"
                                    [disabled]="_pageState == 4 ? true : false"
                                    (click)="_onSave('save')">
                                    <img class="backimage"
                                      [src]="'/assets/menu/'+ _theme +'/save-icon-group.svg'" />
                                      <span>save</span>
                                    </button>
                                  </div>
                                }
                              </div>
                            </div>
                            <div class="col-12">
                              <div class="formsMenuSeparator"></div>
                            </div>
                          </div>
                          <fieldset class="col-12"
                            [class.col-6-imp]="_pageState == 2 || _pageState == 5 || _pageState == 4 || _currentUser.isEnterprise">
                            <div KendoToolTip class="form-group from_but_container special_style_formgroup margin-top-10" style="padding-left: 10px;">
                              <label for="code" class="control-label">{{getLabel("LBL_UOMCode")?.currentText}}</label>
                              <input #kendo_BarcodeGen_Unit_Code
                                type="text"
                                [class.ViewModeDisabledControl]="_pageState == 1"
                                class="k-textbox writebox min-width-0 newFormControlWidth"
                                [placeholder]="'Code'"
                                (keyup.enter)="_barcodeSubmited()"
                                (keydown.Tab)="_barcodeSubmited()"
                                (focus)="_onFocusUnitCode()"
                                (focusout)="_onFocusOutUnitCode()"
                                formControlName="code"
                                entityName="uom"
                                [formControl]="_unitCode"
                                required />
                                <a class="cursor-pointer"
                                  [class.ViewModeHiddenElement]="_pageState == 1 || _pageState == 4"
                                  (click)="_generateBarcodeClick()">
                                  <img class="searchIcon"
                                    [src]="'/assets/menu/'+ _theme +'/auto-generate-icon.svg'" />
                                  </a>
                                  <a title="Edit {{getLabel('LBL_UOMCode')?.currentText}}"
                                    [class.editfieldsIconvisible]="_pageState == 4"
                                    class="editFieldsIcon"
                                    (click)="_openRenameForm('LBL_UOMCode', true)">
                                    <img class="searchIcon"
                                      [src]="'/assets/menu/'+ _theme +'/edit-icon.svg'" />
                                    </a>
                                  </div>
                                  @if (getAuthByLabel('LBL_UOMUnitName')?.canView) {
                                    <div KendoToolTip style="padding-left: 10px;"
                                      class="form-group from_but_container special_style_formgroup margin-top-10">
                                      <label for="uomunitname" class="control-label">{{getLabel("LBL_UOMUnitName")?.currentText}}</label>
                                      <input #Kendo_Unit_Name_Input
                                        (keyup.enter)="_unitNameSubmited()"
                                        (keydown.Tab)="_unitNameSubmited()"
                                        (focus)="_onFocusUnitName()"
                                        (focusout)="_onFocusOutUnitName()"
                                        type="text"
                                        class="k-textbox writebox newFormControlWidth"
                                        [class.ViewModeDisabledControl]="_pageState == 1"
                                        formControlName="unitName"
                                        [attr.disabled]="getAuthByLabel('LBL_UOMUnitName')?.canEdit ? null : 'disabled'"
                                        [attr.required]="getLabel('LBL_UOMUnitName')?.isRequired ? 'required' : null" />
                                        <span class="inputSkipButton" (click)="_skipUnitName()">
                                          skip<img [src]="'/assets/menu/'+ _theme +'/yellow-skip-arrow.svg'" />
                                        </span>
                                        <a title="Edit {{getLabel('LBL_UOMUnitName')?.currentText}}"
                                          [class.editfieldsIconvisible]="_pageState == 4"
                                          class="editFieldsIcon"
                                          (click)="_openRenameForm('LBL_UOMUnitName')">
                                          <img class="searchIcon"
                                            [src]="'/assets/menu/'+ _theme +'/edit-icon.svg'" />
                                          </a>
                                        </div>
                                      }
                                      @if (getAuthByLabel('LBL_UOMMultiplier')?.canView) {
                                        <div KendoToolTip style="padding-left: 10px;"
                                          class="form-group from_but_container special_style_formgroup margin-top-10">
                                          <label for="uommultiplier" class="control-label">{{getLabel("LBL_UOMMultiplier")?.currentText}}</label>
                                          <kendo-numerictextbox #Kendo_Units_Multiplier_Numericbox
                                            (keyup.enter)="_unitsMultiplerSubmited()"
                                            (keydown.Tab)="_unitsMultiplerSubmited()"
                                            (focus)="_onFocusUnitsMultiplier()"
                                            [decimals]=""
                                            [readonly]="_model.isAssignedOnItem"
                                            format="#"
                                            [class.ViewModeDisabledControl]="_pageState == 1"
                                            type="number"
                                            format="{{ quantityFormat }}"
                                            class="k-numerictextbox newFormControlWidth requirednumeric bordered"
                                            [min]="0"
                                            formControlName="multiplier"
                                            required
                                            [attr.disabled]="getAuthByLabel('LBL_UOMMultiplier')?.canEdit ? null : 'disabled'">
                                          </kendo-numerictextbox>
                                          <a title="Edit {{getLabel('LBL_UOMMultiplier')?.currentText}}"
                                            [class.editfieldsIconvisible]="_pageState == 4"
                                            class="editFieldsIcon"
                                            (click)="_openRenameForm('LBL_UOMMultiplier', true)">
                                            <img class="searchIcon"
                                              [src]="'/assets/menu/'+ _theme +'/edit-icon.svg'" />
                                            </a>
                                          </div>
                                        }
                                      </fieldset>
                                    </div>
                                  </div>
                                  @if (_pageState != 2 && _pageState != 5 && _pageState != 4 && !_isLiveEnterprise && !_currentUser.isEnterprise) {
                                    <div class="col-6 special_col_padding ng-star-inserted"
                                      >
                                      <div class="border_sections margin-top-4 bordered-With-charts">
                                        @if ((_currentUser && !_currentUser.isEnterprise)) {
                                          <div class="col-12 appliance-Sharts-Container">
                                            <div class="tabsSection">
                                              <ul class="tabsectionList">
                                                <li class="LS" [class.activetabShart]="_receiveChartActive" (click)="_activateReceiveChart()">
                                                  Receive Stats
                                                </li>
                                                <li [class.activetabShart]="_issueChartActive" (click)="_activateIssueChart()" class="LS">
                                                  Issue Stats
                                                </li>
                                                <li [class.activetabShart]="_inventoryChartActive" (click)="_activateInventoryChart()" class="LS">
                                                  Inventory Stats
                                                </li>
                                              </ul>
                                            </div>
                                            <!--  -->
                                            <!--  -->
                                            <!--  -->
                                            @if (_receiveChartActive) {
                                              <div style="width: 100%" (click)="_openReceiveChartWindow($event)">
                                                <apx-chart style="width: 100%"
                                                  [title]="receiveUnitOfMeasureChart.title"
                                                  [series]="receiveUnitOfMeasureChart.series"
                                                  [chart]="receiveUnitOfMeasureChart.chart"
                                                  [stroke]="receiveUnitOfMeasureChart.stroke"
                                                  [xaxis]="receiveUnitOfMeasureChart.xaxis"
                                                [dataLabels]="receiveUnitOfMeasureChart.dataLabels"></apx-chart>
                                              </div>
                                            }
                                            @if (_issueChartActive) {
                                              <div style="width: 100%" (click)="_openIssueChartWindow($event)">
                                                <apx-chart [title]="issueUnitOfMeasureChart.title"
                                                  [series]="issueUnitOfMeasureChart.series"
                                                  [chart]="issueUnitOfMeasureChart.chart"
                                                  [stroke]="issueUnitOfMeasureChart.stroke"
                                                  [xaxis]="issueUnitOfMeasureChart.xaxis"
                                                [dataLabels]="issueUnitOfMeasureChart.dataLabels"></apx-chart>
                                              </div>
                                            }
                                            @if (_inventoryChartActive) {
                                              <div style="width: 100%" (click)="_openInventoryChartWindow($event)">
                                                <apx-chart [title]="inventoryUnitOfMeasureChart.title"
                                                  [series]="inventoryUnitOfMeasureChart.series"
                                                  [chart]="inventoryUnitOfMeasureChart.chart"
                                                  [stroke]="inventoryUnitOfMeasureChart.stroke"
                                                  [xaxis]="inventoryUnitOfMeasureChart.xaxis"
                                                [dataLabels]="inventoryUnitOfMeasureChart.dataLabels"></apx-chart>
                                              </div>
                                            }
                                          </div>
                                        }
                                      </div>
                                    </div>
                                  }
                                </div>
                              <!-- </div> -->
                            </div>
                          </div>
                          @if ((((_pageState == 4) || (_dataTabs && _dataTabs.length > 0)) && _hasCustomTabs()) || _currentUser.isEnterprise) {
                            <div
                              class="example-wrapper">
                              <div class="row no_row_margin">
                                <div [ngClass]="{'col-8 col-lg-8 col-xl-8': !_currentUser.isEnterprise,'col-12 col-lg-12 col-xl-12':_currentUser.isEnterprise}"
                                  class="responsive_style numericboxtab"
                                  #kendo_tabstrip_wrapper>
                                  <kendo-tabstrip [tabPosition]="_kendoTabStripPosition">
                                    @if (_currentUser && _currentUser.isEnterprise) {
                                      <kendo-tabstrip-tab #accountTab
                                        title="Accounts"
                                        [selected]="_currentUser && _currentUser.isEnterprise"
                                        >
                                        <ng-template kendoTabContent>
                                          <div class="greytabtop menumobilecontainer">
                                            <img class="mobiletabIcon"
                                              [src]="'/assets/menu/'+ _theme +'/fields-menu-icon.svg'" />
                                            </div>
                                            <!-- [class.active]="_addressesCode.value != null && !_selectedAccounts.length"
                                            [class.disabled]="_addressesCode.value == null" -->
                                            <div class="tabcontent tabWizGridInside accountTab"
                                              [class.active]="_addClassActive">
                                              <asap-account-sites-selection
                                                [class.ViewModeDisabledControl]="_pageState == 1"
                                                [disabled]="_pageState == 1"
                                                [selectedAccounts]="_selectedAccounts"
                                                [enableSiteSelection]="false"
                                                [resolver]="_getAccounts"
                                                (onRowSelectionChanges)="_onAccountRowSelectionChanges($event)">
                                              </asap-account-sites-selection>
                                            </div>
                                          </ng-template>
                                        </kendo-tabstrip-tab>
                                      }
                                      <!-- <kendo-tabstrip-tab *ngFor="let item of items; let i = index" [title]="item.city"
                                      [disabled]="item.disabled">
                                      <ng-template kendoTabContent>
                                        <div class="weather">
                                          <h4>{{ item.temp }}<span>&ordm;C</span></h4>
                                          <p>Weather in {{ item.city }} is {{ item.weather }}.</p>
                                        </div>
                                      </ng-template>
                                    </kendo-tabstrip-tab> -->
                                    @for (tab of _dataTabs; track tab) {
                                      @if (tab.isCustom) {
                                        <kendo-tabstrip-tab
                                          [title]="tab.name"
                                          [disabled]="!_tabEnabled">
                                          <ng-template kendoTabContent>
                                            <div class="tabcontent">
                                              <fieldset class="contenttabstyle margin-top-10">
                                                <asap-custom-fields-form [customFields]="_customFields[tab.id]"
                                                  [pageState]="_pageState"
                                                  [accounts]="_selectedAccountIds"
                                                  [formName]="'stock'"
                                                  page="uom"
                                                  [invalidSubmit]="_invalidSubmit"
                                                  (customFieldsValue)="_customFieldsValueChanges($event, tab.id)"
                                                  (customFieldsDeleteValue)="_removeCustomField($event)"
                                                  (customFieldsEditValue)="_openCustomRenameForm($event, tab.id)"
                                                  (customFieldsStatus)="formStatus($event)"
                                                  [_customFieldsValue]="_customFieldsValue">
                                                </asap-custom-fields-form>
                                                <div class="form-group special_style_formgroup">
                                                  <button kendobutton
                                                    class="addNewFieldButton k-button"
                                                    (click)="_addNewField(tab.id)">
                                                    <img class="backimage"
                                                      src="/assets/menu/enterprise/add-icon-green.svg" /><span>Add New Field</span>
                                                    </button>
                                                  </div>
                                                  <div class="form-group special_style_formgroup">
                                                    <button kendobutton
                                                      class="addNewFieldButton k-button"
                                                      (click)="_deactivateTab(tab.id, 'stockItems')">
                                                      <img class="backimage"
                                                        src="/assets/menu/enterprise/add-icon-green.svg" /><span>Deactivate Tab</span>
                                                      </button>
                                                    </div>
                                                  </fieldset>
                                                </div>
                                              </ng-template>
                                            </kendo-tabstrip-tab>
                                          }
                                        }
                                      </kendo-tabstrip>
                                    </div>
                                    @if (_currentUser && _currentUser.isEnterprise) {
                                      <div class="col-4 col-lg-4 col-xl-4 responsive_style"
                                        >
                                        @if (!_currentUser.isEnterprise) {
                                          <div class="borderedNotesContainer"
                                            >
                                            <note #note
                                              [_pageState]="_pageState"
                                              [_model]="_model"
                                            [_page]="_page"></note>
                                          </div>
                                        }
                                      </div>
                                    }
                                  </div>
                                </div>
                              }
                              <div class="row no_row_margin">
                                <div class="col-12">
                                  <button kendobutton
                                    class="addNewtabButton k-button"
                                    (click)="_addNewTab()">
                                    <img class="backimage"
                                      src="/assets/menu/enterprise/add-icon-green.svg" /><span>Add New Tab</span>
                                    </button>
                                  </div>
                                </div>
                                <div class="row no_row_margin">
                                  <div class="col-12">
                                    <button kendobutton
                                      class="reorderTabButton k-button"
                                      (click)="_reorderingtabs()">
                                      <img class="backimage"
                                        src="/assets/menu/enterprise/reorder-tabs-icon.svg" /><span>reorder tabs</span>
                                      </button>
                                    </div>
                                  </div>
                                  <div class="row">
                                    <div class="col-12">
                                      @if (_invalidForm) {
                                        <asap-forms-validation-summary
                                          [form]="_form"
                                          [page]="'uom'"
                                          [customFields]="_customFields"
                                          [customValidation]="_customValidation"
                                          [additionalErrors]="_additionalErrors">
                                        </asap-forms-validation-summary>
                                      }
                                    </div>
                                  </div>
                                </form>
                                @if (CheckIfWeAreInEditMode()) {
                                  <div class="asap-footer">
                                    <ul class="asap-footer-content-list">
                                      <li>
                                        <span class="label-footer">Date Added:</span>{{
                                        _model.createdOn |
                                        dateFormat
                                        }}<span class="separator">.</span><span class="label-footer">Added By User:</span>{{
                                        _model.createdUser?
                                        _model.createdUser.userName : null
                                        }}
                                      </li>
                                      <li>
                                        <span class="label-footer">Last Edited:</span>{{
                                        _model.lastUpdatedOn |
                                        dateFormat
                                        }}<span class="separator">.</span><span class="label-footer">Last Edited By User:</span>{{_model.updatedUser? _model.updatedUser.userName : null}}
                                      </li>
                                    </ul>
                                  </div>
                                }
                                @if (  _editFormActive ||_orderingTabsForm || _deactivatedFieldsForm || _isEditForms || openUnitOfMeasureForm || _receiveChartWindowActive
                                  || _issueChartWindowActive || _deactivatedFormTabsForm) {
                                  <div class="k-overlay"
                                  ></div>
                                }
                              </kendo-window>
                            }
                            @if (_editFormActive) {
                              <kendo-window
                                title="{{ _isCustomfieldsFormValue ? 'Add Custom Fields' : (_isAddTabFormValue ? 'Add New Tabs' : (_isRenameFormValue ? 'Edit Record' : '')) }}"
                                (close)="_closeCustomFields()"
                                class="customFieldsWindow">
                                <!-- <asap-custom-fields [accounts]="_selectedAccountIds" [tabGroup]="_selectedTabId" [labelId]="_selectedLabelId"
                                [labelObjectCode]="_selectedLabelObjectCode" [formName]="'stock'" page="uom"
                                [isCustomfieldsForm]="_isCustomfieldsFormValue" [isCustomtabsForm]="_isAddTabFormValue"
                                [isRenameForm]="_isRenameFormValue" [language]="_language" [isRenameCustomForm]="_isRenameCustomFormValue"
                                [isRenameLabel]="_isRenameLabel">
                              </asap-custom-fields> -->
                              <asap-custom-fields [accounts]="_selectedAccountIds"
                                [tabGroup]="_selectedTabId"
                                [labelId]="_selectedLabelId"
                                [labelObjectCode]="_selectedLabelObjectCode"
                                [formName]="'stock'"
                                page="uom"
                                [isCustomfieldsForm]="_isCustomfieldsFormValue"
                                [isCustomtabsForm]="_isAddTabFormValue"
                                [isRenameForm]="_isRenameFormValue"
                                [language]="_language"
                                [isRenameCustomForm]="_isRenameCustomFormValue"
                                [isRenameLabel]="_isRenameLabel"
                                [isMandatory]="_isMandatory"
                                (closePopup)="ClosePopup($event)"
                                [permissionScope]="_permissionScope">
                              </asap-custom-fields>
                            </kendo-window>
                          }
                          @if (_orderingTabsForm) {
                            <kendo-window
                              title="Tab Reordering"
                              (keydown.enter)="$event.preventDefault()"
                              (close)="_closeOrderingTabsForm()">
                              <div class="row no_row_margin py-2 margin-top-4 border_sections">
                                <div class="col-12">
                                  <button kendoButton class="steps_buttons_class" (click)="_onSaveTabOrdering()">
                                    <img class="backimage" [src]="'/assets/menu/'+ _theme +'/save-icon-group.svg'" />
                                    <span>Save & Close</span>
                                  </button>
                                </div>
                              </div>
                              <div class="row no_row_margin p-3 margin-top-30">
                                @if (false) {
                                  <div class="col-12 margin-top-10">
                                    <div class="form-group">
                                      <label for="itemType" class="control-label">Tab 1</label>
                                      <kendo-combobox [data]="_dataTabsSelected"
                                        [suggest]="true"
                                        [textField]="'name'"
                                        [valueField]="'name'"
                                        placeholder="Accounts/Sites"
                                        class="newFormControlWidth disabled">
                                      </kendo-combobox>
                                    </div>
                                  </div>
                                }
                                @for (item of _dataTabs ; track item; let i = $index) {
                                  <div class="col-12 margin-top-10">
                                    <div class="form-group">
                                      <label for="itemType" class="control-label">Tab {{ i + 1 }}</label>
                                      <kendo-combobox [data]="_dataTabsSelected"
                                        [suggest]="true"
                                        [textField]="'name'"
                                        [valueField]="'name'"
                                        [placeholder]="item.name"
                                        required
                                        class="bordered newFormControlWidth"
                                        (valueChange)="_comboValueChange($event,i)">
                                      </kendo-combobox>
                                    </div>
                                  </div>
                                }
                              </div>
                            </kendo-window>
                          }
                          @if (_deactivatedFieldsForm) {
                            <kendo-window title="Deactivated Fields" (close)="_closeInactiveFields()">
                              <div class="row no_row_margin margin-top-30">
                                <div class="col-12 margin-top-10">
                                  <kendo-grid [data]="_deactivatedFieldsGridData" [scrollable]="'none'">
                                    <kendo-grid-column field="name" title="Fields Name">
                                    </kendo-grid-column>
                                    <kendo-grid-column field="formTab.name" title="Tab Name">
                                    </kendo-grid-column>
                                    <kendo-grid-column field="createdOn" title="Added Date" type="date">
                                      <ng-template kendoGridCellTemplate let-dataItem>
                                        {{dataItem.createdOn | dateFormat}}
                                      </ng-template>
                                    </kendo-grid-column>
                                    <kendo-grid-column field="lastUpdatedOn"
                                      title="Deactivation Date"
                                      type="date">
                                      <ng-template kendoGridCellTemplate let-dataItem>
                                        {{dataItem.lastUpdatedOn | dateFormat}}
                                      </ng-template>
                                    </kendo-grid-column>
                                    <kendo-grid-column field="Command" title="Command">
                                      <ng-template kendoGridCellTemplate let-dataItem>
                                        <div class="action-button action-button-deactivate"
                                          (click)="_reactivate(dataItem)">
                                          <div class="action-button-icon">
                                            <img src="/assets/menu/enterprise/deactivate-icon.svg" />
                                          </div>
                                          <div class="edit-icon-text">Reactivate</div>
                                        </div>
                                      </ng-template>
                                    </kendo-grid-column>
                                  </kendo-grid>
                                </div>
                              </div>
                            </kendo-window>
                          }
                          @if (_receiveChartWindowActive) {
                            <kendo-window
                              title="Receive UM Stats"
                              (close)="_closeReceiveChartWindow()"
                              class="fullWidthFormForm">
                              <div class="col-12">
                                <div class="asap-section-container zero-padding">
                                  <div class="row zeromarginRow">
                                    <div class="col-12 zeroPaddingColumn">
                                      <div class="header-section-gray">
                                        Stock Items - Graph
                                        <span class="float-right pointer-click mt-2 mr-2"></span>
                                      </div>
                                    </div>
                                  </div>
                                  <div class="graph-container-display">
                                    <apx-chart [title]="receiveUnitOfMeasureChart.title"
                                      [series]="receiveUnitOfMeasureChart.series"
                                      [chart]="receiveUnitOfMeasureChart.chart"
                                      [xaxis]="receiveUnitOfMeasureChart.xaxis"
                                      [stroke]="receiveUnitOfMeasureChart.stroke"
                                    [dataLabels]="receiveUnitOfMeasureChart.dataLabels"></apx-chart>
                                  </div>
                                </div>
                                <div class="asap-section-container zero-padding">
                                  <div class="row zeromarginRow">
                                    <div class="col-12 zeroPaddingColumn">
                                      <div class="header-section-gray">
                                        Stock Items - Grid
                                        <span class="float-right pointer-click mt-2 mr-2"></span>
                                      </div>
                                      <asap-grid-layout [page]="'stockItems'"
                                        [pagingEnabled]="false"
                                        [sortingEnabled]="false"
                                        [filteringEnable]="false"
                                        [headerEnable]="false"
                                        [importEnable]="false"
                                        [exportExcelEnable]="false"
                                        [exportPDFEnable]="false"
                                        [orderEnable]="true"
                                        [headerTitle]="'Receive'"
                                        [enableSiteSelection]="false"
                                        [resolver]="_getReceiveUM"
                                        class="ListGrid"
                                        [refreshInitData]="false"
                                        [withHeader]="false">
                                        @for (column of _stockItemsGridColumns; track column) {
                                          @if (column.selected) {
                                            <ng-template pageListColumn
                                              [field]="column.field"
                                              [name]="column.title"
                                              [type]="column.type"
                                              let-item>
                                              <ng-container>
                                                {{getPropByString(item,column.field)}}
                                              </ng-container>
                                            </ng-template>
                                          }
                                        }
                                      </asap-grid-layout>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </kendo-window>
                          }
                          @if (_issueChartWindowActive) {
                            <kendo-window
                              title="Issue UM Stats"
                              (close)="_closeIssueChartWindow()"
                              class="fullWidthFormForm">
                              <div class="col-12">
                                <div class="asap-section-container zero-padding">
                                  <div class="row zeromarginRow">
                                    <div class="col-12 zeroPaddingColumn">
                                      <div class="header-section-gray">
                                        Stock Items - Graph
                                        <span class="float-right pointer-click mt-2 mr-2"></span>
                                      </div>
                                    </div>
                                  </div>
                                  <div class="graph-container-display">
                                    <apx-chart [title]="issueUnitOfMeasureChart.title"
                                      [series]="issueUnitOfMeasureChart.series"
                                      [chart]="issueUnitOfMeasureChart.chart"
                                      [xaxis]="issueUnitOfMeasureChart.xaxis"
                                      [stroke]="issueUnitOfMeasureChart.stroke"
                                    [dataLabels]="issueUnitOfMeasureChart.dataLabels"></apx-chart>
                                  </div>
                                </div>
                                <div class="asap-section-container zero-padding">
                                  <div class="row zeromarginRow">
                                    <div class="col-12 zeroPaddingColumn">
                                      <div class="header-section-gray">
                                        Stock Items - Grid
                                        <span class="float-right pointer-click mt-2 mr-2"></span>
                                      </div>
                                      <asap-grid-layout [page]="'stockItems'"
                                        [pagingEnabled]="false"
                                        [sortingEnabled]="false"
                                        [filteringEnable]="false"
                                        [headerEnable]="false"
                                        [importEnable]="false"
                                        [exportExcelEnable]="false"
                                        [exportPDFEnable]="false"
                                        [orderEnable]="true"
                                        [headerTitle]="'Receive'"
                                        [enableSiteSelection]="false"
                                        [resolver]="_getIssueUM"
                                        class="ListGrid"
                                        [refreshInitData]="false"
                                        [withHeader]="false">
                                        @for (column of _stockItemsGridColumns; track column) {
                                          @if (column.selected) {
                                            <ng-template pageListColumn
                                              [field]="column.field"
                                              [name]="column.title"
                                              [type]="column.type"
                                              let-item>
                                              <ng-container>
                                                {{getPropByString(item,column.field)}}
                                              </ng-container>
                                            </ng-template>
                                          }
                                        }
                                      </asap-grid-layout>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </kendo-window>
                          }
                          @if (_inventoryChartWindowActive) {
                            <kendo-window
                              title="Inventory UM Stats"
                              (close)="_closeInventoryChartWindow()"
                              class="fullWidthFormForm">
                              <div class="col-12">
                                <div class="asap-section-container zero-padding">
                                  <div class="row zeromarginRow">
                                    <div class="col-12 zeroPaddingColumn">
                                      <div class="header-section-gray">
                                        Stock Items - Graph
                                        <span class="float-right pointer-click mt-2 mr-2"></span>
                                      </div>
                                    </div>
                                  </div>
                                  <div class="graph-container-display">
                                    <apx-chart [title]="inventoryUnitOfMeasureChart.title"
                                      [series]="inventoryUnitOfMeasureChart.series"
                                      [chart]="inventoryUnitOfMeasureChart.chart"
                                      [xaxis]="inventoryUnitOfMeasureChart.xaxis"
                                      [stroke]="inventoryUnitOfMeasureChart.stroke"
                                    [dataLabels]="inventoryUnitOfMeasureChart.dataLabels"></apx-chart>
                                  </div>
                                </div>
                                <div class="asap-section-container zero-padding">
                                  <div class="row zeromarginRow">
                                    <div class="col-12 zeroPaddingColumn">
                                      <div class="header-section-gray">
                                        Stock Items - Grid
                                        <span class="float-right pointer-click mt-2 mr-2"></span>
                                      </div>
                                      <asap-grid-layout [page]="'stockItems'"
                                        [pagingEnabled]="false"
                                        [sortingEnabled]="false"
                                        [filteringEnable]="false"
                                        [headerEnable]="false"
                                        [importEnable]="false"
                                        [exportExcelEnable]="false"
                                        [exportPDFEnable]="false"
                                        [orderEnable]="true"
                                        [headerTitle]="'Receive'"
                                        [enableSiteSelection]="false"
                                        [resolver]="_getIssueUM"
                                        class="ListGrid"
                                        [refreshInitData]="false"
                                        [withHeader]="false">
                                        @for (column of _stockItemsGridColumns; track column) {
                                          @if (column.selected) {
                                            <ng-template pageListColumn
                                              [field]="column.field"
                                              [name]="column.title"
                                              [type]="column.type"
                                              let-item>
                                              <ng-container>
                                                {{getPropByString(item,column.field)}}
                                              </ng-container>
                                            </ng-template>
                                          }
                                        }
                                      </asap-grid-layout>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </kendo-window>
                          }
                          <!-- Unit of Measure Chart -->
                          @if (openUnitOfMeasureForm) {
                            <kendo-window
                              title="Unit of Measure Chart"
                              (keydown.enter)="$event.preventDefault()"
                              (close)="UnitOfMeasureChartOnClose()"
                              class="fullWidthFormForm">
                              <div class="col-12">
                                <div class="asap-section-container zero-padding">
                                  <div class="row zeromarginRow">
                                    <div class="col-12 zeroPaddingColumn">
                                      <div class="header-section-gray">
                                        Unit Of Measure - Graph
                                        <span [ngClass]="isUnitOfMeasureChartExpanded == true ? 'k-icon k-i-sort-asc-sm' :  'k-icon k-i-sort-desc-sm'"
                                          class="float-right pointer-click mt-2 mr-2"
                                        (click)="ExpandCollapseUnitOfMeasureChart(isUnitOfMeasureChartExpanded)"></span>
                                      </div>
                                    </div>
                                  </div>
                                  @if (isUnitOfMeasureChartExpanded) {
                                    <div class="graph-container-display">
                                      <apx-chart [title]="unitOfMeasureChart.title"
                                        [series]="unitOfMeasureChart.series"
                                        [chart]="unitOfMeasureChart.chart"
                                        [xaxis]="unitOfMeasureChart.xaxis"
                                        [stroke]="unitOfMeasureChart.stroke"
                                      [dataLabels]="unitOfMeasureChart.dataLabels"></apx-chart>
                                    </div>
                                  }
                                </div>
                                <div class="asap-section-container zero-padding">
                                  <div class="row zeromarginRow">
                                    <div class="col-12 zeroPaddingColumn">
                                      <div class="header-section-gray">
                                        Unit Of Measure - Grid
                                        <span [ngClass]="isUnitOfMeasureGridExpanded == true ? 'k-icon k-i-sort-asc-sm' :  'k-icon k-i-sort-desc-sm'"
                                          class="float-right pointer-click mt-2 mr-2"
                                        (click)="ExpandCollapseUnitOfMeasureGrid(isUnitOfMeasureGridExpanded)"></span>
                                      </div>
                                    </div>
                                  </div>
                                  @if (isUnitOfMeasureGridExpanded) {
                                    <div class="col-12 zeroPaddingColumn">
                                      <kendo-tabstrip [tabPosition]="_kendoTabStripPosition">
                                        <!-- Receive -->
                                        <kendo-tabstrip-tab title="Receive" [selected]="true">
                                          <ng-template kendoTabContent>
                                            <div class="tabcontent">
                                              <fieldset class="contenttabstyle">
                                                <div class="col-12 mb-2 chart-UOM-description">
                                                  <span>Unit Of Measure {{_model.code}}</span>
                                                </div>
                                                @if (_receiveGridColumns) {
                                                  <asap-grid-layout
                                                    [page]="'receiveHistory'"
                                                    [pagingEnabled]="false"
                                                    [sortingEnabled]="true"
                                                    [filteringEnable]="true"
                                                    [headerEnable]="true"
                                                    [importEnable]="true"
                                                    [exportExcelEnable]="true"
                                                    [exportPDFEnable]="true"
                                                    [orderEnable]="true"
                                                    [headerTitle]="'Receive'"
                                                    [enableSiteSelection]="false"
                                                    [resolver]="_getReceiveTransactions"
                                                    class="ListGrid"
                                                    [refreshInitData]="true"
                                                    [withHeader]="false">
                                                    @for (column of _receiveGridColumns; track column) {
                                                      @if (column.selected) {
                                                        @if (column.isTemplate) {
                                                          <ng-template pageListColumn
                                                            [field]="column.field"
                                                            [name]="column.title"
                                                            [type]="column.type"
                                                            let-item>
                                                            @if (column.field == 'stockItem.number') {
                                                              {{item.stockItem?.number}}
                                                            }
                                                            @if (column.field == 'stockItem.description') {
                                                              {{item.stockItem?.description}}
                                                            }
                                                            @if (column.field == 'stockItem.itemType.name') {
                                                              {{item.stockItem?.itemType?.name}}
                                                            }
                                                            @if (column.field == 'stockItem.itemType.description') {
                                                              {{item.stockItem?.itemType?.description}}
                                                            }
                                                            @if (column.field == 'location.code') {
                                                              {{item.location?.code}}
                                                            }
                                                            @if (column.field == 'location.description') {
                                                              {{item.location?.description}}
                                                            }
                                                            @if (column.field == 'stockReceive.vendor.code') {
                                                              {{item.stockReceive?.vendor?.code}}
                                                            }
                                                            @if (column.field == 'stockReceive.vendor.name') {
                                                              {{item.stockReceive?.vendor?.name}}
                                                            }
                                                            @if (column.field == 'stockLocation.expirationDate') {
                                                              {{
                                                              $safeNavigationMigration(item.stockLocation?.expirationDate) | dateFormat
                                                              }}
                                                            }
                                                            @if (column.field == 'stockLocation.udField3') {
                                                              {{item.stockLocation?.udField1}}
                                                            }
                                                            @if (column.field == 'stockLocation.udField3') {
                                                              {{item.stockLocation?.udField2}}
                                                            }
                                                            @if (column.field == 'stockLocation.udField3') {
                                                              {{item.stockLocation?.udField3}}
                                                            }
                                                            @if (column.field == 'stockLocation.udFieldDate1') {
                                                              {{
                                                              $safeNavigationMigration(item.stockLocation?.udFieldDate1) | dateFormat
                                                              }}
                                                            }
                                                            @if (column.field == 'stockLocation.udFieldDate2') {
                                                              {{
                                                              $safeNavigationMigration(item.stockLocation?.udFieldDate2) | dateFormat
                                                              }}
                                                            }
                                                            @if (column.field == 'stockLocation.udFieldDate3') {
                                                              {{
                                                              $safeNavigationMigration(item.stockLocation?.udFieldDate3) | dateFormat
                                                              }}
                                                            }
                                                            @if (column.field == 'stockPurchaseOrder.vendor.code') {
                                                              {{item.stockPurchaseOrder?.vendor.code}}
                                                            }
                                                            @if (column.field == 'stockPurchaseOrder.vendor.name') {
                                                              {{item.stockPurchaseOrder?.vendor.name}}
                                                            }
                                                            @if (column.field == 'user.username') {
                                                              {{item.user?.username}}
                                                            }
                                                            @if (column.field == 'stockItem.description') {
                                                              {{item.stockItem?.description}}
                                                            }
                                                            @if (column.field == 'stockItem.costInfo.cost') {
                                                              {{$safeNavigationMigration(item.stockItem?.costInfo?.cost) | costFormat}}
                                                            }
                                                            @if (column.field == 'stockItem.costInfo.code') {
                                                              {{item.stockItem?.costInfo?.code}}
                                                            }
                                                            @if (column.field == 'stockPurchaseOrder.orderDate') {
                                                              {{item.stockPurchaseOrder?.orderDate}}
                                                            }
                                                            @if (column.field == 'stockItem.category.code') {
                                                              {{item.stockItem?.category?.code}}
                                                            }
                                                            @if (column.field == 'stockItem.category.description') {
                                                              {{item.stockItem?.category?.description}}
                                                            }
                                                            @if (column.field == 'stockItem.inventoryUnitOfMeasure.code') {
                                                              {{item.stockItem?.inventoryUnitOfMeasure?.code}}
                                                            }
                                                            @if (column.field == 'stockItem.receiveUnitOfMeasure.code') {
                                                              {{item.stockItem?.receiveUnitOfMeasure?.code}}
                                                            }
                                                            @if (column.field == 'stockItem.generalDescription') {
                                                              {{item.stockItem?.generalDescription}}
                                                            }
                                                            @if (column.field == 'location.site.id') {
                                                              {{item.location?.site?.id}}
                                                            }
                                                            @if (column.field == 'location.site.name') {
                                                              {{item.location?.site?.name}}
                                                            }
                                                            @if (column.field == 'stockItem.costInfo.extendedCost') {
                                                              {{
                                                              (($safeNavigationMigration(item.stockItem?.costInfo?.cost) /
                                                              $safeNavigationMigration(item.stockItem?.receiveUnitOfMeasure?.multiplier))
                                                              *
                                                              $safeNavigationMigration(item.stockItem?.inventoryUnitOfMeasure?.multiplier)
                                                              * item.quantityReceived) | costFormat
                                                              }}
                                                            }
                                                            @if (column.field == 'stockItem.costInfo.inventoryCost') {
                                                              {{
                                                              (($safeNavigationMigration(item.stockItem?.costInfo?.cost) /
                                                              $safeNavigationMigration(item.stockItem?.receiveUnitOfMeasure?.multiplier))
                                                              *
                                                              $safeNavigationMigration(item.stockItem?.inventoryUnitOfMeasure?.multiplier))
                                                              | costFormat
                                                              }}
                                                            }
                                                          </ng-template>
                                                        }
                                                        @if (!column.isTemplate) {
                                                          <ng-template pageListColumn
                                                            [field]="column.field"
                                                            [name]="column.title"
                                                            [type]="column.type"
                                                            let-item>
                                                            @if (column.type == 'date') {
                                                              {{ item[column.field] | dateFormat }}
                                                            }
                                                            @if (column.type != 'date' && column.field != 'id') {
                                                              {{item[column.field]}}
                                                            }
                                                            @if (column.field == 'id') {
                                                              {{item.stockReceiveId}}
                                                            }
                                                          </ng-template>
                                                        }
                                                      }
                                                    }
                                                  </asap-grid-layout>
                                                }
                                              </fieldset>
                                            </div>
                                          </ng-template>
                                        </kendo-tabstrip-tab>
                                        <!-- Issue -->
                                        <kendo-tabstrip-tab title="Issue">
                                          <ng-template kendoTabContent>
                                            <div class="tabcontent">
                                              <fieldset class="contenttabstyle">
                                                <div class="col-12 mb-2 chart-UOM-description">
                                                  <span>Unit Of Measure {{_model.code}}</span>
                                                </div>
                                                @if (_issueGridColumns) {
                                                  <asap-grid-layout
                                                    [page]="'issueHistory'"
                                                    [pagingEnabled]="false"
                                                    [sortingEnabled]="true"
                                                    [filteringEnable]="true"
                                                    [headerEnable]="true"
                                                    [importEnable]="true"
                                                    [exportExcelEnable]="true"
                                                    [exportPDFEnable]="true"
                                                    [orderEnable]="true"
                                                    [headerTitle]="'Issue'"
                                                    [enableSiteSelection]="false"
                                                    [resolver]="_getIssueTransactions"
                                                    class="ListGrid"
                                                    [refreshInitData]="true"
                                                    [withHeader]="false">
                                                    @for (column of _issueGridColumns; track column) {
                                                      @if (column.selected) {
                                                        @if (!column.isTemplate) {
                                                          <ng-template pageListColumn
                                                            [field]="column.field"
                                                            [name]="column.title"
                                                            [type]="column.type"
                                                            let-item>
                                                            @if (column.type == 'date') {
                                                              {{ item[column.field] | dateFormat }}
                                                            }
                                                            @if (column.type != 'date' && column.type == 'stockIssueId') {
                                                              {{item[column.field]}}
                                                            }
                                                            @if (column.field == 'customer.code') {
                                                              {{item.customer?.code}}
                                                            }
                                                            @if (column.field == 'location.code') {
                                                              {{item.location?.code}}
                                                            }
                                                            @if (column.field == 'id') {
                                                              {{item.stockIssueId |number:'9.0-0' |removeComma}}
                                                            }
                                                            @if (column.field == 'stock.number') {
                                                              {{item.stock.number}}
                                                            }
                                                            @if (column.field == 'availableQuantity') {
                                                              {{item.availableQuantity}}
                                                            }
                                                            @if (column.field == 'issueQuantity') {
                                                              {{item.issueQuantity}}
                                                            }
                                                            @if (column.field == 'inventoryQuantity') {
                                                              {{item.inventoryQuantity}}
                                                            }
                                                            @if (column.field == 'siteId') {
                                                              {{item.siteId}}
                                                            }
                                                            @if (column.field == 'site.name') {
                                                              {{item.site.name}}
                                                            }
                                                            @if (column.field == 'inventoryUOMId') {
                                                              {{item.inventoryUOMId}}
                                                            }
                                                            @if (column.field == 'issueUOMId') {
                                                              {{item.issueUOMId}}
                                                            }
                                                            @if (column.field == 'inventoryNumber') {
                                                              {{item.inventoryNumber}}
                                                            }
                                                            @if (column.field == 'soNumber') {
                                                              {{item.soNumber}}
                                                            }
                                                            @if (column.field == 'issueUnitPrice') {
                                                              {{item.issueUnitPrice | costFormat}}
                                                            }
                                                            @if (column.field == 'issueExtendedPrice') {
                                                              {{item.issueExtendedPrice | costFormat}}
                                                            }
                                                            @if (column.field == 'stock.category.code') {
                                                              {{item.stock?.category?.code}}
                                                            }
                                                            @if (column.field == 'stock.category.description') {
                                                              {{item.stock?.category?.description}}
                                                            }
                                                            @if (column.field == 'stock.generalDescription') {
                                                              {{item.stock?.generalDescription}}
                                                            }
                                                            @if (column.field == 'customer.name') {
                                                              {{item.customer?.name}}
                                                            }
                                                            @if (column.field == 'location.description') {
                                                              {{item.location?.description}}
                                                            }
                                                            @if (column.field == 'stock.description') {
                                                              {{item.stock?.description}}
                                                            }
                                                            @if (column.field == 'customer.address.state') {
                                                              {{getStateString($safeNavigationMigration(item.customer?.customerShipToAddresses))}}
                                                            }
                                                            @if (column.field == 'customer.address.country') {
                                                              {{getCountryString($safeNavigationMigration(item.customer?.customerShipToAddresses))}}
                                                            }
                                                            @if (column.field == 'customer.address.zip') {
                                                              {{getZipString($safeNavigationMigration(item.customer?.customerShipToAddresses))}}
                                                            }
                                                            @if (column.field == 'customer.address.city') {
                                                              {{getCityString($safeNavigationMigration(item.customer?.customerShipToAddresses))}}
                                                            }
                                                            @if (column.field == 'customer.address.addressLine1') {
                                                              {{getAddress1String($safeNavigationMigration(item.customer?.customerShipToAddresses))}}
                                                            }
                                                            @if (column.field == 'customer.address.addressLine2') {
                                                              {{getAddress2String($safeNavigationMigration(item.customer?.customerShipToAddresses))}}
                                                            }
                                                            @if (column.field == 'stock.costInfo.cost') {
                                                              {{$safeNavigationMigration(item.stock?.costInfo?.cost) | costFormat}}
                                                            }
                                                            @if (column.field == 'stock.inventoryCost') {
                                                              {{
                                                              (($safeNavigationMigration(item.stock?.costInfo?.cost) /
                                                              $safeNavigationMigration(item.stock?.receiveUnitOfMeasure?.multiplier)) *
                                                              $safeNavigationMigration(item.stock?.inventoryUnitOfMeasure?.multiplier)) |
                                                              costFormat
                                                              }}
                                                            }
                                                            @if (column.field == 'stock.extendedCost') {
                                                              {{
                                                              (($safeNavigationMigration(item.stock?.costInfo?.cost) /
                                                              $safeNavigationMigration(item.stock?.receiveUnitOfMeasure?.multiplier)) *
                                                              $safeNavigationMigration(item.stock?.inventoryUnitOfMeasure?.multiplier) *
                                                              item.quantityMoved) | costFormat
                                                              }}
                                                            }
                                                            @if (column.field == 'user.username') {
                                                              {{item.user?.username}}
                                                            }
                                                          </ng-template>
                                                        }
                                                      }
                                                    }
                                                  </asap-grid-layout>
                                                }
                                              </fieldset>
                                            </div>
                                          </ng-template>
                                        </kendo-tabstrip-tab>
                                        <!-- Inventory -->
                                        <kendo-tabstrip-tab title="Inventory">
                                          <ng-template kendoTabContent>
                                            <div class="tabcontent">
                                              <fieldset class="contenttabstyle">
                                                <div class="col-12 mb-2 chart-UOM-description">
                                                  <span>Unit Of Measure {{_model.code}}</span>
                                                </div>
                                                @if (_inventoryGridColumns) {
                                                  <asap-grid-layout
                                                    [page]="'inventories'"
                                                    [pagingEnabled]="false"
                                                    [sortingEnabled]="true"
                                                    [filteringEnable]="true"
                                                    [headerEnable]="true"
                                                    [importEnable]="true"
                                                    [exportExcelEnable]="true"
                                                    [exportPDFEnable]="true"
                                                    [orderEnable]="true"
                                                    [headerTitle]="'Inventory'"
                                                    [enableSiteSelection]="false"
                                                    [resolver]="_getInventory"
                                                    class="ListGrid"
                                                    [refreshInitData]="true"
                                                    [withHeader]="false">
                                                    @for (column of _inventoryGridColumns; track column) {
                                                      @if (column.selected) {
                                                        @if (_isEnterprise) {
                                                          @if (!column.isTemplate) {
                                                            <ng-template pageListColumn
                                                              [field]="column.field"
                                                              [name]="column.title"
                                                              [type]="column.type"
                                                              let-item>
                                                              @if (column.type == 'date') {
                                                                {{ item[column.field] | dateFormat }}
                                                              }
                                                              @if (column.type != 'date') {
                                                                {{item[column.field]}}
                                                              }
                                                            </ng-template>
                                                          }
                                                          @if (column.isTemplate) {
                                                            <ng-template pageListColumn
                                                              [field]="column.field"
                                                              [name]="column.title"
                                                              [type]="column.type"
                                                              let-item>
                                                              @if (column.field == 'CategoryImage') {
                                                                <img src="{{ item[column.field] }}"
                                                                  alt="{{ item.name }}"
                                                                  title="{{ item.name }}"
                                                                  width="50" />
                                                                }
                                                                @if (column.field == 'action') {
                                                                  <kendo-combobox class="listActions" [placeholder]="'Actions'">
                                                                  </kendo-combobox>
                                                                }
                                                              </ng-template>
                                                            }
                                                          }
                                                          @if (!_isEnterprise) {
                                                            @if (!column.isTemplate) {
                                                              <ng-template pageListColumn
                                                                [field]="column.field"
                                                                [name]="column.title"
                                                                [type]="column.type"
                                                                let-item>
                                                                @if (column.type == 'date') {
                                                                  {{ item[column.field] | dateFormat }}
                                                                }
                                                                @if (column.type != 'date') {
                                                                  {{item[column.field]}}
                                                                }
                                                              </ng-template>
                                                            }
                                                            @if (column.isTemplate) {
                                                              <ng-template pageListColumn
                                                                [field]="column.field"
                                                                [name]="column.title"
                                                                [type]="column.type"
                                                                let-item>
                                                                @if (column.field == 'stockItem.itemType.name') {
                                                                  {{item.stockItem?.itemType?.name}}
                                                                }
                                                                @if (column.field == 'stockItem.costType.code') {
                                                                  {{item.stockItem?.costType?.code}}
                                                                }
                                                                @if (column.field == 'stockItem.receiveUnitOfMeasure.code') {
                                                                  {{item.stockItem.receiveUnitOfMeasure?.code}}
                                                                }
                                                                @if (column.field == 'stockItem.receiveUnitOfMeasure.multiplier') {
                                                                  {{item.stockItem.receiveUnitOfMeasure?.multiplier}}
                                                                }
                                                                @if (column.field == 'location.code') {
                                                                  {{item.location?.code}}
                                                                }
                                                                @if (column.field == 'stockItem.number') {
                                                                  {{item.stockItem?.number}}
                                                                }
                                                                @if (column.field == 'site.account.name') {
                                                                  {{item.site?.account?.name}}
                                                                }
                                                                @if (column.field == 'site.name') {
                                                                  {{item.site?.name}}
                                                                }
                                                              </ng-template>
                                                            }
                                                          }
                                                        }
                                                      }
                                                    </asap-grid-layout>
                                                  }
                                                </fieldset>
                                              </div>
                                            </ng-template>
                                          </kendo-tabstrip-tab>
                                        </kendo-tabstrip>
                                      </div>
                                    }
                                  </div>
                                </div>
                                <div class="col-12 margin-top-10">
                                  <button kendoButton
                                    class="steps_buttons_class"
                                    (click)="UnitOfMeasureChartOnClose()">
                                    <img class="backimage"
                                      [src]="'/assets/menu/'+ _theme +'/close-schedule-report-icon-green.svg'" />
                                      <span>close</span>
                                    </button>
                                  </div>
                                </kendo-window>
                              }
                              @if (_isEditForms) {
                                <asap-edit-forms
                                  (close)="_onCloseEditForms($event)"
                                  (saved)="_closeCustomFields()"
                                  [page]="_page"
                                  [permissionScope]="_permissionScope">
                                </asap-edit-forms>
                              }
                              @if (  _editFormActive ||_orderingTabsForm || _deactivatedFieldsForm || _isEditForms || openUnitOfMeasureForm) {
                                <div class="k-overlay"
                                ></div>
                              }
                              @if (_deactivatedFormTabsForm) {
                                <kendo-window
                                  title="Deactivated Forms"
                                  (close)="_closeInactiveFormTabs()"
                                  style="z-index: 10050;">
                                  <div class="row no_row_margin margin-top-30">
                                    <div class="col-12 margin-top-10">
                                      <kendo-grid [data]="_deactivatedFormTabsGridData" [scrollable]="'none'">
                                        <!-- <kendo-grid-column field="name" title="Fields Name">
                                      </kendo-grid-column> -->
                                      <kendo-grid-column field="name" title="Tab Name">
                                      </kendo-grid-column>
                                      <kendo-grid-column field="createdOn" title="Added Date" type="date">
                                        <ng-template kendoGridCellTemplate let-dataItem>
                                          {{dataItem.createdOn | dateFormat}}
                                        </ng-template>
                                      </kendo-grid-column>
                                      <kendo-grid-column field="lastUpdatedOn"
                                        title="Deactivation Date"
                                        type="date">
                                        <ng-template kendoGridCellTemplate let-dataItem>
                                          {{dataItem.lastUpdatedOn | dateFormat}}
                                        </ng-template>
                                      </kendo-grid-column>
                                      <kendo-grid-column field="Command" title="Command">
                                        <ng-template kendoGridCellTemplate let-dataItem>
                                          <div class="action-button action-button-deactivate"
                                            (click)="_reactivateFormTab(dataItem)">
                                            <div class="action-button-icon">
                                              <img src="/assets/menu/enterprise/deactivate-icon.svg" />
                                            </div>
                                            <div class="edit-icon-text">Reactivate</div>
                                          </div>
                                        </ng-template>
                                      </kendo-grid-column>
                                    </kendo-grid>
                                  </div>
                                </div>
                              </kendo-window>
                            }
